import { isAfter, isBefore } from 'date-fns';

export default function isBetween(currentDate: Date, fromDate?: Date | null, toDate?: Date | null): boolean {
    if ((fromDate && isBefore(currentDate, fromDate)) || (toDate && isAfter(currentDate, toDate))) {
        return false;
    }

    return true;
}
